// extracted by mini-css-extract-plugin
export var backgroundImage = "campaign-module--backgroundImage--0a968";
export var campaignArticlesGrid = "campaign-module--campaign-articles-grid--c606c";
export var campaignContent = "campaign-module--campaign-content--4219a";
export var campaignContentInner = "campaign-module--campaign-content-inner--ea5cb";
export var intro = "campaign-module--intro--5bb7f";
export var sponsor = "campaign-module--sponsor--c4e54";
export var sponsorButton = "campaign-module--sponsor-button--16151";
export var sponsorImageWrapper = "campaign-module--sponsor-image-wrapper--0887c";
export var sponsorTxt = "campaign-module--sponsor-txt--31d3d";